import cn from "classnames";
import { ButtonVariants } from "./types";

const DEFAULT_BUTTON_CLASSNAME = "rounded-20 p-2";

export const BUTTON_STYLE_VARIANTS = {
  [ButtonVariants.PRIMARY]: cn(
    "bg-purple-base text-white-base border border-opacity-100 hover:brightness-125",
    DEFAULT_BUTTON_CLASSNAME
  ),
  [ButtonVariants.SECONDARY]: cn(
    "bg-white-pink text-purple-base border border-black-base border-opacity-20 hover:bg-blue-dark/20",
    DEFAULT_BUTTON_CLASSNAME
  ),
  [ButtonVariants.GRAY]: cn(
    "bg-gray-light text-purple-base border border-black-base border-opacity-20 hover:bg-blue-dark/20",
    DEFAULT_BUTTON_CLASSNAME
  ),
  [ButtonVariants.SIMPLE_SECONDARY]: cn(
    "px-5 py-2 text-purple-base bg-gray-base/10 border-none hover:bg-blue-dark hover:bg-opacity-20",
    DEFAULT_BUTTON_CLASSNAME
  ),
  [ButtonVariants.SHADOW_PRIMARY]: cn(
    "bg-white-pink bg-opacity-20 text-white-base hover:shadow-purple-medium",
    DEFAULT_BUTTON_CLASSNAME
  ),
  [ButtonVariants.SHADOW_SECONDARY]: cn(
    "bg-black-base bg-opacity-40 text-white-base hover:shadow-purple-dark",
    DEFAULT_BUTTON_CLASSNAME
  ),
};
